import onDocumentReady from 'shared/onDocumentReady';
import { createApp } from '~/vue/createApp';
import SiteFooter from './SiteFooter.vue';

// see site_header/index.js for what the conversion from `new Vue({el, render})` changes
function initVue() {
    const el = document.getElementById('site-footer-component');
    if (!el) {
        return;
    }
    createApp(SiteFooter).mount(el);
}

onDocumentReady(initVue);
